import {
  CatalogItemGroupDto,
  UntrackedCatalogItemGroupDto,
} from '@peritasai/types';
import { ChecklistItemEntity } from './checklist-item.entity';

/**
 * Catalog Item Group Entity
 * Wraps CatalogItemGroupDto
 */
export class CatalogItemGroupEntity {
  public readonly catalogItemId: string;
  public readonly name: string;
  public readonly productNumber: string;
  public readonly manufacturer: string;
  public readonly description?: string;
  public readonly metadata?: Record<string, unknown> | null;
  public readonly note?: string;
  public readonly items: ChecklistItemEntity[];

  constructor(dto: CatalogItemGroupDto) {
    this.catalogItemId = dto.catalogItemId;
    this.name = dto.name;
    this.productNumber = dto.productNumber;
    this.manufacturer = dto.manufacturer;
    this.description = dto.description;
    this.metadata = dto.metadata;
    this.note = dto.note;
    this.items = dto.items.map((item) => new ChecklistItemEntity(item));
  }

  public get allocatedCount(): number {
    return this.items.filter((i) => i.isAllocated).length;
  }

  public get totalCount(): number {
    return this.items.length;
  }

  public get hasAllocatedItems(): boolean {
    return this.allocatedCount > 0;
  }
}

/**
 * Untracked Catalog Item Group Entity
 * Wraps UntrackedCatalogItemGroupDto
 */
export class UntrackedCatalogItemGroupEntity {
  public readonly catalogItemId: string;
  public readonly name: string;
  public readonly productNumber: string;
  public readonly manufacturer: string;
  public readonly description?: string;
  public readonly cost?: number;
  public readonly metadata?: Record<string, unknown> | null;
  public readonly note?: string;
  public readonly items: ChecklistItemEntity[];

  constructor(dto: UntrackedCatalogItemGroupDto) {
    this.catalogItemId = dto.catalogItemId;
    this.name = dto.name;
    this.productNumber = dto.productNumber;
    this.manufacturer = dto.manufacturer;
    this.description = dto.description;
    this.cost = dto.cost;
    this.metadata = dto.metadata;
    this.note = dto.note;
    this.items = dto.items.map((item) => new ChecklistItemEntity(item));
  }

  public get allocatedCount(): number {
    return this.items.filter((i) => i.isAllocated).length;
  }

  public get totalCount(): number {
    return this.items.length;
  }

  public get hasAllocatedItems(): boolean {
    return this.allocatedCount > 0;
  }
}
